import { BarElement, ChartType, Plugin } from 'chart.js';

export interface IHoverBarBackgroundOptions {
  /**
   * @description Default value is true
   */
  display?: boolean;
  backgroundColor?: string;
}

declare module 'chart.js' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface PluginOptionsByType<TType extends ChartType = ChartType> {
    hoverBarBackground?: IHoverBarBackgroundOptions;
  }
}

export const hoverBarBackgroundPlugin: Plugin<'bar'> = {
  id: 'hoverBarBackground',

  beforeDatasetsDraw: (chart, _args, options: IHoverBarBackgroundOptions) => {
    if (!(options.display ?? true)) {
      return;
    }

    const tooltip = chart.tooltip;

    const activeElements = tooltip?.getActiveElements();

    if (!activeElements || activeElements.length === 0) {
      return;
    }

    const activeElement = activeElements[0].element as BarElement;
    const { x, width } = activeElement.getProps(['x', 'width'], true);

    if (typeof x !== 'number' || typeof width !== 'number') {
      return;
    }

    const { ctx } = chart;
    const topY = chart.scales['y'].top;
    const bottomY = chart.scales['y'].bottom;

    ctx.save();
    ctx.fillStyle = options.backgroundColor || 'rgba(0, 0, 0, 0.05)';
    ctx.fillRect(x - width / 2, topY, width, bottomY - topY);
    ctx.restore();
  },
};
